'use client';

import '@ui5/webcomponents/dist/Token.js';
import { withWebComponent } from '../../internal/withWebComponent.js';
/**
 * Tokens are small items of information (similar to tags) that mainly serve to visualize previously selected items.
 *
 * __Note:__ This component is a web component developed by the UI5 Web Components’ team.
 *
 * [UI5 Web Components Storybook](https://sap.github.io/ui5-webcomponents/playground/?path=/docs/main-MultiInput)
 */
const Token = withWebComponent('ui5-token', ['text'], ['readonly', 'selected'], ['closeIcon'], ['select']);
Token.displayName = 'Token';
export { Token };